import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Observable, Subject, combineLatest, takeUntil } from 'rxjs';
import { ContactDetails } from 'src/app/models/interface/CAM/traveler-management';
import { RegistationUtilitiesService } from 'src/app/modules/registration/services/registation-utilities.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { noHtmlTagsValidator } from 'src/app/shared/Validators/special-character-validation';
import { ContentService } from '../../services/content.service';
import { LocalSessionStorage } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { environment } from 'src/environments/environment';
import { NgIf, NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
export interface Country {
  name: string;
  code: string;
}

export interface StateGroup {
  letter: string;
  names: {
    name: string;
    code: string;
    isdCode: string;
    countryFlag: string;
  }[];
}
export interface State {
  name: string;
  code: string;
}
export interface City {
  cityName: string;
  cityCode: string;
}
export const _filter = (
  opt: { name: string; code: string }[],
  value: string
): { name: string; code: string }[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.name.toLowerCase().includes(filterValue));
};
@Component({
    selector: 'app-contact-details-form',
    templateUrl: './contact-details-form.component.html',
    styleUrls: ['./contact-details-form.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatSuffix, NgStyle, MatError, NgSelectComponent, AutoBlurSelectDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatSelect, MatOption, MatButton, MatProgressSpinner]
})
export class ContactDetailsFormComponent implements OnInit, OnDestroy {
  ContactDetailsForm: FormGroup;
  editcontact: boolean = false;
  paxTitles: any[] = [];
  paxcontactDetails!: ContactDetails;
  editcomapany: boolean = false;
  budgetOptions: any = [];
  businessOptions: any = [];
  employeeOptions: any = [];
  userId: string = '';
  guid: string = '';
  // companySettingDetails: any = {};
  // isProfileViewRestricted: boolean = false;
  loginType: any
  isCityDirty = false;
  isCityDirty1 = false;
  noResultsFound = false;
  countries: any[] = [];
  filteredCountries: any;
  filteredCities: { cityName: string; cityCode: string }[] = [];
  selectedCity: City | null = null;
  selectedCity1: City | null = null;
  PreviousCity: string = '';
  PreviousCityCode: string = 'SA';
  PreviousCountry: string = '';
  PreviousCountryCode: string = '';
  countriesLists: any[] = [];
  cityControl = new FormControl('');
  cityControl1 = new FormControl('');
  PreviousCity1: string = '';
  PreviousCityCode1: string = 'SA';
  PreviousCountry1: string = '';
  PreviousCountryCode1: string = '';
  countriesLists1: any[] = [];
  filteredCountries1: any;
  filteredCities1: { cityName: string; cityCode: string }[] = [];
  noResultsFound1 = false;
  saUserId: string | null = '';
  CountryGroupOptions: Observable<StateGroup[]> = new Observable<StateGroup[]>();
  CountryGroupOptions1: Observable<StateGroup[]> = new Observable<StateGroup[]>();

  Loader: any = {
    isSpinner: false,
    isEditableClicked: false
  }
  allCities: any;
  allCities1: any;
  commonObjPipes: any = {
    countyname: { pipe: [], all: [] },
    countryCode: { pipe: [], all: [] },
    city: { pipe: [], all: [] },
    city1: { pipe: [], all: [] },
  }

  hasEmployeeData: boolean = false;
  noDataPersonalInfo!: boolean
  content: any;
  originalFormValue: any;
  private readonly destroy$ = new Subject<void>();
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  constructor(
    private readonly fb: FormBuilder,
    private readonly _CamApiService: CamService,
    private readonly _ApiService: ApiService,
    private readonly registrationUtility: RegistationUtilitiesService,
    private readonly crypto: CryptoService,
    private readonly _ToastrApiService: ToastrApiService,
    public _CommonService: CommonService,
    private readonly contentService: ContentService,
    private readonly dictionaryContentService:DisctionaryContent,
    private readonly travelerManagement:TravelerManagement
  ) {
    this.ContactDetailsForm = this.fb.group({
      Email: ['', [Validators.email, Validators.minLength(5), Validators.maxLength(250)]],
      MobileNo: ['', [Validators.minLength(8), Validators.maxLength(12), noHtmlTagsValidator()]],
      HomeAddress: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(250), noHtmlTagsValidator()]],
      CountryGroup: [null, [Validators.required, noHtmlTagsValidator()]],
      CountryGroup1: [null, [Validators.required, noHtmlTagsValidator()]],
      PostalCode: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(10)]],
      StreetAddress: ['', [Validators.minLength(10), Validators.maxLength(250), noHtmlTagsValidator()]],
      PostalCodeStreet: ['', [Validators.minLength(5), Validators.maxLength(10)]],
      city: [null, [Validators.required]],
      city1: [null, [Validators.required]],
      cityControl: [''],
      cityControl1: [''],
      streetSuburb: [''],
      homesuburb: [''],
      streetstate: [''],
    });
  }
  ngOnInit(): void {
    combineLatest({
      content: this.contentService.content$, dictionary: this.dictionaryContentService.content$
    }).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = {
        ...res.content,
        dictionary: res.dictionary
      }
    });

    this.disableBusinessFields()//Disable business details address permanently

    this.userId = sessionStorage.getItem('userId') || '';
    this.guid = sessionStorage.getItem('guid') || '';
    this.loginType = this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string
    const stored = localStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS) ?? sessionStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS);
    // this.companySettingDetails = stored && stored !== 'undefined' ? JSON.parse(stored) : {};
    // const travelerGUID = localStorage.getItem('travelerGUID')?.toLowerCase();
    // const userGuid = localStorage.getItem('userGuid')?.toLowerCase();
    // this.isProfileViewRestricted = this.companySettingDetails?.restrictAmendmentInTravelerProfile && (travelerGUID !== userGuid);
    // if (this.isProfileViewRestricted) {
    //   this.ContactDetailsForm.disable();
    // }

    this.loadPaxTitles();

    this._ApiService.getCountriesData().then(($res) => {
      this.countriesLists = this._CommonService.groupCountriesFilter($res);
    }).catch((err) => {
      console.log(err);
    });

    if (this.userId && this.guid) {
      this.loadUserExecutiveData();
    } else {
      this.editcontact = false;
      this.Loader.isEditableClicked = false;
    }
    this.noDataPersonalInfo = this._CommonService.getData('camSidebar')
  }

  private loadPaxTitles() {
    this._CamApiService.GetPaxTittle().then((response: any) => {
      if (response?.status === 'Success') {
        this.paxTitles = response.data || [];
      }
    }).catch((error: any) => console.error('Error fetching Pax Titles:', error));
  }

  private loadUserExecutiveData() {
    this.editcontact = true;
    this.Loader.isEditableClicked = true;
    let payload = {
      "subagentId": this.crypto.getValueFromKey('SUBAGENTID') as string,
      "userRole": this.crypto.getValueFromKey(
        'ISCORPTRAVELARRANGER'
      ) as string,
      B2BUserId: this.userId
    }
    this._CamApiService.PostUserExecutiveV1(this.guid, payload).then(async (response: any) => {
      if (response?.status === 'Success') {
        const user = response.data.contactDetails;
        this.paxcontactDetails = response.data.contactDetails;
        this.patchUserForm(this.paxcontactDetails);
      } 
    }).catch((error: any) => console.error('Error fetching Pax Contact details:', error));
  }

  private patchUserForm(user: ContactDetails) {

    // 👉 Extract number after "-"
    const mobileNumber = user.alternateNumber
      ? user.alternateNumber.split('-').pop()
      : '';

    this.ContactDetailsForm.patchValue({
      Email: user.alternateEmail || '',
      MobileNo: mobileNumber || '',
      HomeAddress: user.homeAddress.address || '',
      PostalCode: user.homeAddress.postCode || '',
      StreetAddress: user.businessDetails.businessAddress || '',
      PostalCodeStreet: user.businessDetails.businessPostCode || '',
      city: user.homeAddress.city || null,
      city1: user.businessDetails.businessCity || null,
      CountryGroup: user.homeAddress.countryOfResidence || null,
      CountryGroup1: user.businessDetails.businessCountryOfResidence || null
    });
    this.originalFormValue = this.ContactDetailsForm.getRawValue();
    this.resetFormState();
    this.hasEmployeeData = this._CommonService.hasAnyValue(this.ContactDetailsForm.value)// value is in form or not
    if (this.hasEmployeeData) {
      this.Loader.isEditableClicked = true;
    } else {
      this.Loader.isEditableClicked = false;
    }

    // Load cities for both home and business addresses
    if (user.homeAddress.countryOfResidence) {
      this.filteredCitiesFunc(user.homeAddress.countryOfResidence, 'city', false);
    }
    if (user.businessDetails.businessCountryOfResidence) {
      this.filteredCitiesFunc(user.businessDetails.businessCountryOfResidence, 'city1', false);
    }
  }

  updateRegistrationIdValidators(countryCode: string) {

    const CountryGroupControl = this.ContactDetailsForm.get('CountryGroup');
    if (countryCode === 'SA') {
      CountryGroupControl?.setValidators([]);
    } else {
      CountryGroupControl?.setValidators([]);
    }
  }
  updateRegistrationIdValidators1(countryCode: string) {
    const CountryGroupControl1 = this.ContactDetailsForm.get('CountryGroup1');
    if (countryCode === 'SA') {
      CountryGroupControl1?.setValidators([]);
    } else {
      CountryGroupControl1?.setValidators([]);
    }

  }
  filterCountries(event: any, cityKey: string) {
    this.markFormDirty();
    this.filteredCitiesFunc(event?.isoCode ?? event, cityKey);
  }

  /** Mark form as dirty so Save button enables when user changes any value (used by ng-select and other controls). */
  markFormDirty(): void {
    this.ContactDetailsForm.markAsDirty();
  }

  getImageUrl(path: string): string {
    if (!path) return '';
  
    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');
  
    return `${base}/${cleanPath}`;
  }   

  filteredCitiesFunc(countryCode: any, cityKey: string, isReset: boolean = true) {
    this.commonObjPipes[cityKey].all = [];
    this.commonObjPipes[cityKey].pipe = [];
    if (isReset) {
      this.ContactDetailsForm.get(cityKey)?.setValue(null);
    }
    this.registrationUtility.getCities(countryCode?.code ?? countryCode, '').subscribe((cities) => {
      this.commonObjPipes[cityKey].all = cities;
      this.commonObjPipes[cityKey].pipe = cities;
      this.noResultsFound = cities.length === 0;
    }, (error) => { console.error('Error fetching city data', error); this.noResultsFound = true; });

  }
  Editcontact() {
    this.travelerManagement.traveler_detail_click('Edit');
    this.editcontact = true;
    this.Loader.isEditableClicked = false;
  }
  Cancel() {
    this.travelerManagement.traveler_detail_click('Cancel');
    if (this.hasEmployeeData && this.originalFormValue) {
      this.ContactDetailsForm.reset(this.originalFormValue);
      this.resetFormState();
      this.Loader.isEditableClicked = true;
      //this.loadUserExecutiveData();
    }
    else {
      this.Loader.isEditableClicked = false;
      this.ContactDetailsForm.reset();

      this.resetFormState();
    }
  }

  private resetFormState(): void {

    Object.values(this.ContactDetailsForm.controls).forEach(control => {
      control.setErrors(null);
      control.markAsPristine();
      control.markAsUntouched();
      control.updateValueAndValidity({ emitEvent: false });
    });

    this.noResultsFound = false;
    this.noResultsFound1 = false;
    this.isCityDirty = false;
    this.isCityDirty1 = false;
  }

  getCountryName(
    selectedCountry: { name: string; code: string } | null
  ): string {
    return selectedCountry ? selectedCountry.name : '-';
  }
  onCityInput1(event: Event): void {
    this.isCityDirty1 = true;
    const input = (event.target as HTMLInputElement).value.trim();
    if (input !== this.PreviousCity1) {
      this.cityControl1?.setErrors({ InvalidInput: true });
      this.cityControl1?.markAsTouched();
      this.cityControl1?.markAsDirty();
    } else {
      this.cityControl1?.setErrors(null);
      this.cityControl1?.markAsUntouched();
    }
    const stateGroupControl1 = this.ContactDetailsForm.get('CountryGroup1');
    if (!stateGroupControl1?.value) {
      this.filteredCities1 = [];
      this.noResultsFound1 = true;
      this.ContactDetailsForm.get('city1')?.setErrors({ noResults: true });
      return;
    }
    const countryCode1 = (stateGroupControl1.value as { code: string }).code;
    if (!countryCode1 || input.length === 0) {
      this.filteredCities1 = [];
      this.noResultsFound1 = true;
      this.ContactDetailsForm.get('city1')?.setErrors({ noResults: true });
      return;
    }
    this.registrationUtility.getCities(countryCode1, input).subscribe({
      next: (cities) => {
        this.filteredCities1 = cities;
        this.noResultsFound1 = cities.length === 0;
        if (this.noResultsFound1) {
          this.ContactDetailsForm.get('city1')?.setErrors({ noResults: true });
        } else {
          this.ContactDetailsForm.get('city1')?.setErrors(null);
        }
      },
      error: (error) => {
        console.error('Error fetching city data', error);
        this.noResultsFound1 = true;
        this.filteredCities1 = [];
        this.ContactDetailsForm.get('city1')?.setErrors({ noResults: true });
      }
    });
  }
  onCitySelected1(city: City): void {
    if (!city) return;
    this.selectedCity1 = city;
    this.ContactDetailsForm.get('city1')?.setValue(this.selectedCity1);
  }
  onCityInput(event: Event): void {

    this.isCityDirty = true;
    const input = (event.target as HTMLInputElement).value.trim(); // Trim to remove accidental spaces
    if (input !== this.PreviousCity) {
      this.cityControl?.setErrors({ InvalidInput: true });
      this.cityControl?.markAsTouched();
      this.cityControl?.markAsDirty();
    } else {
      this.cityControl?.setErrors(null);
      this.cityControl?.markAsUntouched();
    }
    const stateGroupControl = this.ContactDetailsForm.get('CountryGroup');
    if (!stateGroupControl?.value) {
      this.filteredCities = [];
      this.noResultsFound = true;
      this.ContactDetailsForm.get('city')?.setErrors({ noResults: true });
      return;
    }
    const countryCode = (stateGroupControl.value as { code: string }).code;
    if (!countryCode || input.length === 0) {
      this.filteredCities = [];
      this.noResultsFound = true;
      this.ContactDetailsForm.get('city')?.setErrors({ noResults: true });
      return;
    }
    this.registrationUtility.getCities(countryCode, input).subscribe({
      next: (cities) => {
        this.filteredCities = cities;
        this.noResultsFound = cities.length === 0;
        if (this.noResultsFound) {
          this.ContactDetailsForm.get('city')?.setErrors({ noResults: true });
        } else {
          this.ContactDetailsForm.get('city')?.setErrors(null);
        }
      },
      error: (error) => {
        console.error('Error fetching city data', error);
        this.noResultsFound = true;
        this.filteredCities = [];
        this.ContactDetailsForm.get('city')?.setErrors({ noResults: true });
      }
    });
  }
  onCitySelected(city: City) {

    this.selectedCity = city;
    this.ContactDetailsForm.get('city')?.setValue(this.selectedCity);
  }
  onKeyPress(event: KeyboardEvent): void {
    const invalidChars = ['+', '-', '_'];
    const isNumeric = /^[0-9]$/.test(event.key);
    if (!isNumeric && !invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }
  Onlyrs(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const currentInputValue = inputElement.value;
    if (currentInputValue.length >= 64) {
      event.preventDefault();
      return;
    }
    const typedChar = event.key;
    if (typedChar === '.' && currentInputValue.endsWith('.')) {
      this.ContactDetailsForm.get('email')?.setErrors({ customEmailValidator: true });
      event.preventDefault();
    }
  }
  blockInvalidCharacters(event: KeyboardEvent): void {
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }
  blockNumbers(event: KeyboardEvent): void {
    if (!/^[a-zA-Z\s]$/.test(event.key)) {
      event.preventDefault();
    }
  }
  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault();
  }
  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }
  blockInvalidCharacters1(event: KeyboardEvent): void {
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  onSave(): void {

    this.Loader.isSpinner = true;
    if (this.ContactDetailsForm.invalid) {
      this._ToastrApiService.show('error', 'Please correct the form errors before submission.');
      this.Loader.isSpinner = false;
      return;
    }
    const formValues = this.ContactDetailsForm.value;
    const payload = {
      branch: this.crypto.getValueFromKey("SABRANCHID"),
      subAgentUserId: sessionStorage.getItem('userId') || '',
      alternateEmailAddress: formValues.Email || '',
      alternateNumber: formValues.MobileNo || '',
      homeAddress: formValues.HomeAddress || '',
      countryOfResidence: formValues.CountryGroup || '',
      homeStateName: formValues.State || '',
      homeCityName: formValues.city || '',
      homePostcode: formValues.PostalCode || '',
      businessAddress: formValues.StreetAddress || '',
      businessCountryOfResidence: formValues.CountryGroup1 || '',
      businessStateName: formValues.streetstate || '',
      businessCityName: formValues.city1 || '',
      businessPostcode: formValues.PostalCodeStreet || ''
    };
    this._CamApiService.UpdatecontactDetails(payload).then((res) => {
      this._ToastrApiService.show('success', "Contact details updated successfully.");
      this.travelerManagement.traveler_detail_click('Save');
      setTimeout(() => {
        this.Loader.isSpinner = false;
        this.Loader.isEditableClicked = true;
      }, 2000);
    }).catch((error) => {
      console.error('Error saving data:', error);
      this._ToastrApiService.show('error', 'Failed to update Contact details.');
      this.Loader.isSpinner = false;
    });
  }
  findCountryByName(name: string): any {
    let foundCountry = null;
    this.CountryGroupOptions.subscribe(groups => {
      groups.forEach(group => {
        const match = group.names.find(item => item.name === name);
        if (match) {
          foundCountry = match;
        }
      });
    });
    return foundCountry;
  }
  onCityBlur() {

    const cityControl = this.ContactDetailsForm.get('city');
    const cityInput = cityControl?.value;
    const isValidCity = this.filteredCities.some(city => city.cityName.toLowerCase() === cityInput.toLowerCase());
    if (cityInput && !isValidCity) {
      cityControl.setErrors({ 'invalidCity': true });
      this.noResultsFound = true;
    } else {
      cityControl?.setErrors(null);
      this.noResultsFound = false;
      if (this.filteredCities.length === 1 && isValidCity) {
        cityControl?.setValue(this.filteredCities[0].cityName);
      }
    }
  }
  onCityBlur1() {

    const cityControl = this.ContactDetailsForm.get('city1');
    const cityInput = cityControl?.value;
    const isValidCity = this.filteredCities1.some(city => city.cityName.toLowerCase() === cityInput.toLowerCase());
    if (cityInput && !isValidCity) {
      cityControl.setErrors({ 'invalidCity1': true });
      this.noResultsFound = true;
    } else {
      cityControl?.setErrors(null);
      this.noResultsFound = false;
      if (this.filteredCities1.length === 1 && isValidCity) {
        cityControl?.setValue(this.filteredCities1[0].cityName);
      }
    }
  }

  preventHtmlInjection(event: KeyboardEvent): void {
    const invalidChars = ['<', '>', '"', "'", '`', ';', '&', '\\', '/', '=', '{', '}', '[', ']'];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  homeAddressInvalidInput(event: KeyboardEvent): void {
    if (!/^[a-zA-Z0-9 .,\-#/]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  disableBusinessFields() {
    this.ContactDetailsForm.get('StreetAddress')?.disable();
    this.ContactDetailsForm.get('CountryGroup1')?.disable();
    this.ContactDetailsForm.get('streetstate')?.disable();
    this.ContactDetailsForm.get('city1')?.disable();
    this.ContactDetailsForm.get('streetSuburb')?.disable();
    this.ContactDetailsForm.get('PostalCodeStreet')?.disable();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}